import { useNavigate } from "react-router-dom";
import { ArrowLeft, FileText, Settings2, ClipboardCheck } from "lucide-react";
import { PermissaoEnum } from "@workflow/types";

import { TopBarSection } from "@/components/shared/SecaoBarraSuperior";
import { withPermissionPage } from "@/components/hocs/WithPermissionPage";
import {
  SavingProgressDialog,
  SavingStepConfig,
} from "@/components/campos-formulario/form-shell/SavingProgressDialog";
import { useComunicadoSistemaCreateForm } from "@/hooks/comunicados/use-comunicado-sistema-create-form";
import { ComunicadoSistemaForm } from "./components/ComunicadoSistemaForm";

const SAVING_STEPS: SavingStepConfig[] = [
  { id: "conteudo", label: "Registrando o conteúdo", icon: <FileText className="size-4" /> },
  { id: "config", label: "Aplicando a configuração", icon: <Settings2 className="size-4" /> },
  { id: "finalizando", label: "Finalizando", icon: <ClipboardCheck className="size-4" /> },
];

const ComunicadoSistemaCreatePage = () => {
  const navigate = useNavigate();
  const controller = useComunicadoSistemaCreateForm();

  return (
    <div className="space-y-2">
      <TopBarSection
        title="Novo comunicado"
        showButton
        buttonLabel="Voltar"
        buttonIcon={<ArrowLeft />}
        onButtonClick={() => navigate("/admin/comunicados")}
      />

      <ComunicadoSistemaForm controller={controller} />

      <SavingProgressDialog
        open={controller.savingOpen}
        status={controller.savingStatus}
        steps={SAVING_STEPS}
        title="Criando comunicado"
        description={
          controller.publicou
            ? "Estamos registrando e publicando o comunicado."
            : "Estamos registrando o rascunho do comunicado."
        }
        successTitle={controller.publicou ? "Comunicado publicado!" : "Comunicado criado!"}
        successDescription={
          controller.publicou
            ? "Já está no ar para o público-alvo (ou agendado, se o início for no futuro)."
            : "Publique na lista para deixá-lo vigente."
        }
        errorTitle="Não foi possível criar"
        errorDescription="Algo deu errado. Tente novamente."
        errorActionLabel="Tentar de novo"
        onComplete={controller.handleSavingComplete}
        onClose={controller.handleSavingErrorClose}
      />
    </div>
  );
};

export default withPermissionPage(ComunicadoSistemaCreatePage, [
  PermissaoEnum.COMUNICADO_SISTEMA_MANAGE,
]);
